module.exports = __webpack_public_path__ + "resource/img/back.c85c80ff.svg";